/**
 * EventCalendarService
 * The church calendar on EventManagement (public, Ready, non-deleted events) plus the Carpool
 * visibility switch.
 * Route: events/api/events/calendar (any signed-in user; rides-visibility needs Admin, RidesAdmin or
 * EventsAdmin, or Rides.Events.Manage / Event.Update)
 */
import { BaseService } from '../base/BaseService';
import { unwrapEventsResponse as unwrap } from './unwrapEventsResponse';
export class EventCalendarService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EventCalendarService.DEFAULT_SERVICE_PATH,
            basePath: EventCalendarService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET api/events/calendar?from&to&typeId&ridesOnly. Ordered by start. */
    async getCalendar(query = {}) {
        const res = await this.getCalendarRaw(query);
        return res.data ?? [];
    }
    getCalendarRaw(query = {}) {
        return this.http.get(this.buildUrlWithParams(undefined, {
            from: query.from,
            to: query.to,
            typeId: query.typeId,
            ridesOnly: query.ridesOnly || undefined,
        }));
    }
    /** GET api/events/calendar/{id}. No visibility filter. */
    async getById(id) {
        return unwrap(await this.getByIdRaw(id), `Calendar event ${id} not found`);
    }
    getByIdRaw(id) {
        return this.http.get(this.buildUrl(String(id)));
    }
    /** GET api/events/calendar/types. Active categories with their calendar defaults. */
    async getTypes() {
        const res = await this.getTypesRaw();
        return res.data ?? [];
    }
    getTypesRaw() {
        return this.http.get(this.buildUrl('types'));
    }
    /** PUT api/events/calendar/{id}/rides-visibility. */
    async setRidesVisibility(id, request) {
        return unwrap(await this.setRidesVisibilityRaw(id, request), `Could not update event ${id}`);
    }
    setRidesVisibilityRaw(id, request) {
        return this.http.put(this.buildUrl(`${id}/rides-visibility`), request);
    }
}
EventCalendarService.DEFAULT_SERVICE_PATH = 'events';
EventCalendarService.BASE_PATH = 'api/events/calendar';
//# sourceMappingURL=EventCalendarService.js.map